<template>
  <div class="training-response-modal" :class="{ success: success }">
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">
          {{ success ? 'Parabéns!' : 'Não foi dessa vez!' }}
        </p>
      </header>
      <section class="modal-card-body">
        <div v-if="success" class="success-container">
          <p>Você acertou todas as questões do treinamento e ganhou:</p>
          <div class="points">
            <p class="points__number">{{ points }}</p>
            <p class="points__title">{{ points > 1 ? 'Pontos' : 'Ponto' }}</p>
          </div>
        </div>
        <div v-else class="failure-container">
          <p>
            Você acertou
            <span>{{ score }}/{{ total }}</span>
            questões! Faça o treinamento mais uma vez e tente novamente assim
            que quiser!
          </p>
        </div>
      </section>
      <footer class="modal-card-foot">
        <button type="button" v-app-button.clear @click="$parent.close()">
          Fechar
        </button>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  name: 'training-response-modal',
  props: ['success', 'score', 'points', 'total'],
};
</script>

<style lang="scss" scoped>
.training-response-modal {
  .modal-card {
    &-head {
      background: var(--color-danger);
    }

    &-title {
      color: #fff;
    }
  }

  &.success {
    .modal-card {
      &-head {
        background: var(--color-success);
      }
    }
  }
}

.success-container {
  text-align: center;

  p {
    font-size: 1.2em;
    color: var(--text-color);
  }

  .points {
    margin-top: 16px;
    text-align: center;

    &__number {
      font-size: 3em;
      font-weight: bold;
      color: var(--color-success);
    }

    &__title {
      font-size: 1em;
      font-weight: 500;
      text-transform: uppercase;
    }
  }
}

.failure-container {
  p {
    font-size: 1.2em;
    color: var(--text-color);

    span {
      color: var(--color-danger);
      font-weight: bold;
      letter-spacing: 2px;
      font-size: 1.4em;
    }
  }
}
</style>
